class Auth {
  constructor() {
    this.authenticated = false;
  }

  login() {
    if (
      localStorage.getItem("token") !== null ||
      localStorage.getItem("token") !== "" ||
      localStorage.getItem("token") !== undefined
    ) {
      this.authenticated = true;
    }
  }

  logout() {
    this.authenticated = false;
  }

  isAuthenticated() {
    return this.authenticated;
  }
}

export default new Auth();
